import { CampaignPostsState } from "./campaignPosts.types";

export const initialState: CampaignPostsState = {
  data:[],
  loading: false,
  error: null,
};
